import styled from "styled-components";
import { Box, Checkbox } from "@mui/material";
import BIButton from "../../../components/common/Button";
import { colors } from "../../../theme/colors";

export const FixedHeader = styled(Box)`
  background: ${colors.primary};
  padding: 40px 0;
  position: relative;
`;

export const ActionButton = styled(BIButton)`
  background-color: ${colors.orange.secondary} !important;
  color: ${colors.primary};
  border: 1px solid ${colors.orange.secondary} !important;
  border-radius: 25px !important;
  padding: 12px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  min-width: 145px !important;
  box-shadow: none !important;
  text-transform: none !important;

  &:hover {
    background-color: white !important;
    border: 1px solid ${colors.primary} !important;
  }
`;

export const BackButton = styled(BIButton)`
  background-color: ${colors.primary} !important;
  color: ${colors.white.main} !important;
  border: 1px solid #003864;
  border-radius: 50% !important;
  padding: 12px !important;
  font-size: 16px !important;
  font-weight: 500;
  width: 18px !important;
  height: 18px !important;
  box-shadow: none !important;
`;

export const CustomCheckbox = styled(Checkbox)`
  color: transparent;
  padding: 0px !importan;

  & .MuiSvgIcon-root {
    font-size: 2rem;
    border: 1px solid ${colors.primary};
    border-radius: 6px !important;
    background-color: white;
    width: 28px;
    height: 28px;
    position: relative;
  }

  &:not(.Mui-checked) .MuiSvgIcon-root {
    color: transparent !important;
    border-color: ${colors.primary};
  }

  &.Mui-checked .MuiSvgIcon-root {
    color: ${colors.primary} !important;
    border-color: ${colors.primary} !important;
    background-color: ${colors.green.light};
  }

  &:hover .MuiSvgIcon-root {
    border-color: ${colors.orange.light};
  }
`;

export const CustomBanner = styled(Box)(({ backgroundImage }) => ({
  width: "100%",
  height: "370px",
  marginBottom: "0rem",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "contain",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",

  "@media (max-width: 768px)": {
    marginLeft: "1rem",
    marginRight: "1rem",
    width: "calc(100% - 2rem)",
  },

  "@media (max-width: 480px)": {
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
    width: "calc(100% - 3rem)",
  },
}));
